<div class="p-3 container-fluid">

    
     <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">
         Preliminary Discussion
        </h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span
            class="badge"
            [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }"
          >
            {{
              stepDetails?.step_status == 0
                ? "INITIATION PENDING"
                : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-blue me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.can_edit">
          
          <button
            class="btn btn-primary me-2"
            (click)="routeConfig.emit({isRouteConfig: true})"
            [disabled]="commentForm?.invalid"
          >
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_initiator">
          <button class="btn btn-success" (click)="IRA.emit('Initiate')">
            <i class="pi pi-play me-1"></i> Initiate
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_approver">
          <button class="btn btn-success" (click)="IRA.emit('Approve')">
            <i class="pi pi-check-circle me-1"></i> Approve
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.is_recommender">
          <button class="btn btn-info" (click)="IRA.emit('Recommend')">
            <i class="pi pi-thumbs-up me-1"></i> Recommend
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <hr class="my-3" />



      <!-- Document Upload Section -->
  <div class="row mb-4">
    <div class="col-lg-12">
      <div class="card shadow-sm border-0">
        <div class="card-body p-4">
          <div class="d-flex align-items-center mb-3">
            <i class="pi pi-file text-primary me-2"></i>
            <h5 class="card-title mb-0">MoM</h5>
          </div>
            <!-- <app-upload-document>
            </app-upload-document> -->
            <app-upload-document [title]="'Preliminary Discussion Document'" [isEditable]="stepDetails?.can_edit"></app-upload-document>
          <!-- <p class="text-muted mb-4">Please upload your document in PDF, DOCX, CSV, JPEG, JPG, or PNG format (Max size: 200MB)</p> -->
          
          <!-- Upload Area -->
          <!-- <div class="upload-container mb-4" 
               *ngIf="stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || (stepDetails?.step_status != 'approved' && userID == 6)">
            <div class="upload-area p-4 text-center border rounded" >
             
              
              <p-fileUpload 
                mode="basic" 
                chooseLabel="Browse Files" 
                (uploadHandler)="onUpload($event)"
                [auto]="true" 
                [customUpload]="true" 
                #fileUpload 
                [multiple]="false" 
                [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'" 
                [maxFileSize]="209715200"
                styleClass="p-button-rounded p-button-outlined">
              </p-fileUpload>
            </div>
          </div> -->

          <!-- Uploaded File Display -->
          <!-- <div *ngIf="uploadedFileName || uploadedUrl">
            <div class="uploaded-file-card p-3 bg-light rounded d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <i class="pi pi-file me-3 text-primary" style="font-size: 1.5rem;"></i>
                <div>
                  <p class="mb-0 fw-semibold">
                    <a [href]="apiUrl + uploadedUrl" target="_blank" class="text-decoration-none">
                      {{ uploadedFileName || getFileName(uploadedUrl) }}
                    </a>
                  </p>
                  <small class="text-muted">Uploaded successfully</small>
                </div>
              </div>
              <div class="d-flex gap-2">
                <a [href]="apiUrl + uploadedUrl" target="_blank" class="btn btn-sm btn-outline-primary"  *ngIf="uploadedUrl">
                  <i class="pi pi-eye"></i>
                </a>
                
                  <i class="pi pi-times"  (click)="clearUpload(fileUpload)" *ngIf="uploadedFileName"></i>
                
              </div>
            </div>
          </div> -->

          <!-- No Files State -->
          <!-- <div *ngIf="!uploadedFileName && !uploadedUrl && 
                      !(stepDetails?.is_initiator || stepDetails?.is_approver || stepDetails?.is_recommender || 
                      (stepDetails?.step_status != 'approved' && userID == 6))" 
               class="no-file-placeholder p-3 text-center bg-light rounded">
            <i class="pi pi-inbox text-muted mb-2" style="font-size: 1.5rem;"></i>
            <p class="mb-0 text-muted">No files uploaded</p>
          </div> -->
        </div>
      </div>
    </div>
  </div>


    <!-- <form [formGroup]="commentForm">
        <div class="mb-4 editor-container" [class.readonly-editor]="isEditorDisabled">
            <label class="mb-2 d-block">
              Comment <b class="text-danger">*</b>

            </label>
              <editor [init]="init" formControlName="comment"  [disabled]="isEditorDisabled" ></editor>
        </div>
    </form> -->
    <div class="row">
      <div class="card shadow-sm border-0">
      <div class="card-body p-4">
        <form [formGroup]="commentForm">
          <!-- <div class="editor-field" [class.readonly-editor]="isEditorDisabled"> -->
            <div class="editor-field" disabled="isEditorDisabled">
            <label class="form-label-left">
              Comment <span class="text-warning">*</span>
            </label>
            <div class="editor-container">
              <editor 
                [init]="init" 
                formControlName="comment"  
                [disabled]="isEditorDisabled"
                placeholder="Type your justification here...">
              </editor>
            </div>

            <div *ngIf="commentForm.controls['comment'].invalid && commentForm.controls['comment'].touched" 
                 class="text-danger small mt-2">
              Comment is required
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
    <!-- </div>
</div> -->


<!-- <p-toast position="top-center" key="confirm" (onClose)="onReject()" [baseZIndex]="9999">
  <ng-template let-message pTemplate="message">
      <div class="container-fluid">
          <div class="row mb-3">
              <div class="col-12">
                  <div class="font-medium text-lg my-3 text-900">
                      {{ message.summary }}
                  </div>
              </div>
          </div>
          
          <div class="row mb-3 justify-content-center">
            <div class="col-12 d-flex align-items-center justify-content-center" style="gap: 8px;">
              <p-checkbox [(ngModel)]="confirmChecked" binary="true" inputId="confirmCb"></p-checkbox>
              <b for="confirmCb" class="ms-2 mb-0 cursor-pointer d-flex align-items-center">
                This is final approval
              </b>
            </div>
          </div>
          
          <div class="row">
              <div class="col-12 d-flex align-items-center justify-content-between gap-2">
                  <button size="small" label="Confirm" class="btn btn-success"  (click)="onConfirm()"><i class="pi pi-check-circle"></i>  Submit</button>
                   <button size="small" label="Cancel" class="btn btn-info" (click)="routeconfig()"><i class="pi pi-times-circle"></i> Route Config </button>
              </div>
          </div>
      </div>
  </ng-template>
</p-toast> -->